import { APIError } from '../types/errors';

export function handleAPIError(error: any): APIError {
  if (error instanceof APIError) {
    return error;
  }

  if (error.response) {
    // Server responded with error status
    return APIError.fromResponse(error.response);
  }

  if (error.request) {
    // Request was made but no response received
    if (error.code === 'ECONNABORTED') {
      return APIError.timeoutError();
    }
    return APIError.networkError();
  }

  // Something else happened
  return APIError.unknownError(error.message || 'Unknown error');
}

export function getErrorMessage(error: unknown): string {
  if (error instanceof APIError) {
    return error.message;
  }

  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === 'string') {
    return error;
  }

  return 'An unexpected error occurred';
}

export function isRetryableError(error: APIError): boolean {
  // Retry on network errors, timeouts, and 5xx server errors
  return error.isNetworkError || error.isTimeoutError || error.isServerError;
}

export function getRetryDelay(attempt: number): number {
  // Exponential backoff: 1s, 2s, 4s, 8s, etc.
  return Math.min(1000 * Math.pow(2, attempt), 30000);
}
